import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../lib/cn';
const CloseButton = forwardRef(({ onClick, className }, ref) => (_jsx("button", { ref: ref, type: "button", onClick: (event) => {
        event.stopPropagation();
        onClick();
    }, "aria-label": "Close", className: cn('absolute top-6 right-6 z-30 flex h-11 w-11 items-center justify-center rounded-sm', 'border border-border-subtle bg-bg-elevated text-[1.75rem] leading-none text-text-secondary', 'cursor-pointer transition-colors duration-150 hover:border-border-hover hover:text-text-primary motion-reduce:transition-none', 'focus-visible:border-border-accent focus-visible:shadow-focus-ring', className), children: "\u00D7" })));
CloseButton.displayName = 'CloseButton';
export { CloseButton };
export default CloseButton;
